// extracted by mini-css-extract-plugin
export default {"buttonAddToCart":"buttonCartSvg_buttonAddToCart__zEaYB","buttonInCart":"buttonCartSvg_buttonInCart__aFyy6"};